<template>
  <div class="df_top">

    <div class="df_img df_flex">
      <div class="df_logo"><img src="@/assets/images/logo.png"/></div>
      <div class="nav-center">
        <router-link class="item" :class="{ link_active: linkActive(route) }" v-for="route in navigation"
                     :key="route.value" :to="{ path: route.path }">{{ route.label }}
        </router-link>
      </div>
      <div class="login df_flex_center">
        <div v-if="userInfo" class="login_out df_flex df_align_center">
          <el-avatar :size="30" :src="require('@/assets/images/active/logo_enterprise.png')"></el-avatar>
          <el-dropdown @command="dropdownCommand">
            <div class="login_out_info">
              <span class="el-dropdown-link">
                {{ userInfo.userName }}
                <i class="el-icon-caret-bottom"></i>
              </span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <!--                            <el-dropdown-item command="consult">微咨询管理</el-dropdown-item>-->
              <el-dropdown-item command="user">企业中心</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else class="df_flex df_align_center">
          <div class="login_btn" @click="dialogVisible = true">登录</div>
          <div class="login_btn" @click="dialogVisible = true">注册</div>
        </div>
      </div>
    </div>
    <div class="df_banner" v-if="showBanner"><img :src="showBanner"/></div>
    <!--    微咨询-->
    <img v-if="userInfo" class="img_consult"
         src="@/assets/images/aijqr.png"
         ref="dragImage" @mousedown="startDrag" @click="consult">
    <!--    AI对话-->
    <ConsultDiolog v-if="showConsult" class="consult_diolog" @dialogClose="dialogClose"
                   @consultService="consultService"/>
    <el-dialog :visible.sync="dialogVisible" width="5rem" @close="clearForm">
      <div slot="title" class="dialog_title">欢迎登录</div>
      <div class="dialog_body">
        <div class="dialog_body_input df_flex_center">
          <p class="phone">+86</p>
          <el-input v-model.number="mobileForm.username" maxlength="11" placeholder="手机号"></el-input>
        </div>
        <div class="dialog_body_input df_flex_center">
          <el-input v-model.number="mobileForm.code" maxlength="6" placeholder="验证码"></el-input>
          <p class="code" :class="{ disabled: !isSendable }" @click="isSendable && sendCode()">
            {{ isSending ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}</p>
        </div>
        <div class="dialog_body_btn df_flex_center" @click="loginBtn"
             :style="{ background: $isValidPhoneNumber(mobileForm.username) && mobileForm.code && isChecked ? '#1d68ff' : '#bdc3d9' }">
          登录
        </div>
        <div class="dialog_body_check df_flex_center">
          <el-checkbox v-model="isChecked">
            我已阅读并同意
            <span>《用户协议》</span>
            <span>、</span>
            <span>《隐私条款》</span>
          </el-checkbox>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="咨询工单"
        :visible.sync="serviceDiolog"
        class="service-diolog"
        width="30%">
      <div>
        <el-form>
          <el-form-item label="咨询标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入咨询内容"></el-input>
          </el-form-item>
          <el-form-item label="咨询内容" prop="theInfo">
            <el-input type="textarea" :rows="6" v-model="form.theInfo" placeholder="请输入咨询内容"></el-input>
          </el-form-item>
          <el-form-item label="咨询附件" prop="attachment">
            <image-upload :limit="5" v-model="form.attachment"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancel">取 消</el-button>
    <el-button type="primary" @click="serviceSubmit">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {loginApi} from '@/api/login'
import {mapGetters} from 'vuex'
import ConsultDiolog from '../ConsultDiolog/index.vue'
import {firmApi} from "@/api/firm";
import ImageUpload from "@/components/ImageUpload/component-upload-image.vue";
import {askOrderAdd} from "@/api/consult";

export default {
  name: 'dfHeader',
  data() {
    return {
      srcImgList: [
        {value: '1', showPath: '/', srcImg: require('@/assets/images/home.png')},
        {value: '2', showPath: '/notice', srcImg: require('@/assets/images/notice/back.png')},
        {value: '3', showPath: '/Work', srcImg: require('@/assets/images/work/back.png')},
        {value: '4', showPath: '/active/more', srcImg: require('@/assets/images/cover_active2.png')},
        {value: '5', showPath: '/consult', srcImg: require('@/assets/images/consult/back.png')},
        {value: '6', showPath: '/work_point,/work_point/more', srcImg: require('@/assets/images/work_point/back.png')},
        {value: '7', showPath: '/about', srcImg: require('@/assets/images/about/back.png')},
        {value: '8', showPath: '/supermarket', srcImg: require('@/assets/images/client/back.png')},
        {value: '9', showPath: '/policy', srcImg: require('@/assets/images/client/back.png')},
      ], // 封面图片列表
      dialogVisible: false, // 登录对话框
      mobileForm: {
        username: '',
        code: '',
        // 密码登录 = 0 密码登录 1 验证码登录
        type: 1
      },
      isSending: false,
      countdown: 0,
      serviceDiolog: false,
      firmInfo: void 0,
      form: {
        title: '',
        theInfo: '',
        attachment: []
      },
      isChecked: false, // 是否勾选登录协议
      showConsult: false // 控制对话框显示
    }
  },
  components: {
    ImageUpload,
    ConsultDiolog
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'navigation']),
    // 是否可以发送验证码
    isSendable() {
      return /^1[3456789]\d{9}$/.test(this.mobileForm.username) && !this.isSending && this.countdown === 0
    },
    linkActive() {
      return ({name}) => {
        if (name === '/') return this.$route.path === name
        else return this.$route.path.includes(name)
      }
    },
    showBanner() {
      let srcImg = this.srcImgList.find(item => {
        return item.showPath.split(',').includes(this.$route.path)
      })?.srcImg
      return srcImg
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.dragImage);
    document.addEventListener('mouseup', this.stopDrag);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.dragImage);
    document.removeEventListener('mouseup', this.stopDrag);
  },
  methods: {
    consult() {
      if (this.showConsult) {
        // 先移除show类触发关闭动画
        const dialog = document.querySelector('.consult_diolog')
        dialog.classList.remove('show')

        // 动画结束后执行关闭操作
        setTimeout(() => {
          this.showConsult = !this.showConsult
          // 恢复滚动
          document.body.style.overflow = ''
          // 移除遮罩层
          const mask = document.getElementById('consultMask')
          if (mask) {
            document.body.removeChild(mask)
          }
        }, 300)
      } else {
        this.showConsult = !this.showConsult
        // 禁止滚动
        document.body.style.overflow = 'hidden'
        // 添加遮罩层
        const mask = document.createElement('div')
        mask.className = 'consult-mask'
        mask.style.position = 'fixed'
        mask.style.top = '0'
        mask.style.left = '0'
        mask.style.width = '100%'
        mask.style.height = '100%'
        mask.style.background = 'rgba(0,0,0,0.1)'
        mask.style.zIndex = '999'
        mask.id = 'consultMask'
        document.body.appendChild(mask)

        // 立即触发动画
        setTimeout(() => {
          const dialog = document.querySelector('.consult_diolog')
          dialog.classList.add('show')
        }, 10)
      }
    },
    dialogClose() {
      // 先移除show类触发关闭动画
      const dialog = document.querySelector('.consult_diolog')
      dialog.classList.remove('show')

      // 动画结束后执行关闭操作
      setTimeout(() => {
        this.showConsult = false
        // 恢复滚动
        document.body.style.overflow = ''
        // 移除遮罩层
        const mask = document.getElementById('consultMask')
        if (mask) {
          document.body.removeChild(mask)
        }
      }, 300) // 与CSS过渡时间保持一致
    },
    consultService() {
      // 获取企业信息
      firmApi.isApplyFor().then(({data}) => {
        this.firmInfo = data
        if (data && data.status === '1') {
          this.serviceDiolog = true
          document.body.style.overflow = ''
          // 移除遮罩层
          const mask = document.getElementById('consultMask')
          if (mask) document.body.removeChild(mask)
        } else {
          let text = data && data.status === '0' ? '您已提交企业认证至审核,是否进行查看?' : '此功能需要企业认证,是否进行跳转?'
          this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 恢复滚动
            document.body.style.overflow = ''
            // 移除遮罩层
            const mask = document.getElementById('consultMask')
            if (mask) document.body.removeChild(mask)
            data && data.status === '0' ? this.$router.push('/user') : this.$router.push('/authentication')

          }).catch(() => {
          });
        }
      })
    },
    cancel() {
      this.form = {
        title: '',
        theInfo: '',
        attachment: ''
      }
      this.serviceDiolog = false
    },
    serviceSubmit() {
      if (!this.form.title) {
        return
      }
      if (!this.form.theInfo) {
        return
      }
      let obj = {
        title: this.form.title,
        theInfo: this.form.theInfo,
        attachment: this.form.attachment,
        askerId: this.$store.state.auth.userInfo.userId
      }
      askOrderAdd(obj).then(() => {
        this.$message({
          message: '提交成功',
          type: 'success'
        });
        this.serviceDiolog = false
        this.form = {
          title: '',
          theInfo: '',
          attachment: []
        }
      })
    },
    async sendCode() {
      if (this.countdown > 0 || this.isSending) {
        return // 防止重复点击发送
      }
      this.isSending = true
      const {code} = await loginApi.sendSms({
        phoneNumber: this.mobileForm.username,
        // 验证码类型（0注册 1 登录 2修改密码 3 解绑 4忘记密码）
        type: 1
      })
      if (code == 200) {
        this.isSending = false
        this.startCountdown()
      }
    },
    dropdownCommand(e) {
      let userId = ''
      console.log(e)
      switch (e) {
        case 'user':
          this.viewDetails()
          break
        case 'logout':
          this.loginOut()
          break
        case 'consult':
          // this.$router.push('http://localhost:8080/counselling/consultHall')
          // 跳转新页面
          console.log(this.$store.state.auth.userInfo)
          userId = this.$store.state.auth.userInfo.userId
          window.open(`https://zxqy.jnsme.cn:8100/tokenLogin?id=${userId}&tenantId=${this.$store.state.auth.userInfo.tenantId}`, '_blank')
          break
      }
    },
    startCountdown() {
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },

    async loginBtn() {
      const {mobileForm, $notify, $isValidPhoneNumber, $store} = this

      if (!$isValidPhoneNumber(mobileForm.username)) {
        return $notify.warning({message: '手机号码格式有误'})
      }

      if (!mobileForm.code) {
        return $notify.warning({message: '请输入验证码'})
      }

      if (!this.isChecked) {
        return $notify.warning({message: '请勾选用户协议'})
      }

      try {
        const {code} = await loginApi.checkVerificationCode(mobileForm)
        if (code == 200) {
          // await this.$store.dispatch('phoneLogin', this.mobileForm.username)
          await $store.dispatch('login', mobileForm)
          await $store.dispatch('getInfo')
          $notify.success({message: '登录成功'})

          await this.$store.dispatch('getEnterpriseData') // 登录完之后，获取企业绑定信息（活动页面可跳转到发布，要用到数据，所以提前获取）
        }
        this.dialogVisible = false
      } catch (message) {
        console.error('登录或获取用户信息时发生错误:', message)
      }
    },

    // 清空表单
    clearForm() {
      this.mobileForm = {
        username: '',
        code: '',
        type: 1
      }
      this.isChecked = false
    },

    // 退出
    loginOut(res) {
      console.log(res)
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        await this.$store.dispatch('clearAuth')
        this.$notify.success({message: '退出成功'})
      })
    },

    // 查看个人信息
    async viewDetails() {
      // 如果企业有绑定信息存在  跳转个人中心 否则 跳转到完善企业信息
      if (!this.$store.getters.enterpriseData) await this.$store.dispatch('getEnterpriseData') // 获取企业绑定信息
      this.$router.push({name: this.$store.getters.enterpriseData ? 'UserIndex' : 'UserAuthentication'})
    },
    // 图片移动
    startDrag(e) {
      this.isDragging = true;
      const img = this.$refs.dragImage;
      const rect = img.getBoundingClientRect();
      this.dragStartX = e.clientX - rect.left;
      this.dragStartY = e.clientY - rect.top;
      img.style.cursor = 'grabbing';
    },
    stopDrag() {
      if (this.isDragging) {
        this.isDragging = false;
        this.$refs.dragImage.style.cursor = 'grab';
      }
    },
    dragImage(e) {
      if (this.isDragging) {
        const img = this.$refs.dragImage;
        const maxX = window.innerWidth - img.offsetWidth;
        const maxY = window.innerHeight - img.offsetHeight;

        let x = e.clientX - this.dragStartX;
        let y = e.clientY - this.dragStartY;

        // 限制在可视范围内
        x = Math.max(0, Math.min(x, maxX));
        y = Math.max(0, Math.min(y, maxY));

        img.style.left = x + 'px';
        img.style.top = y + 'px';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.df_top {
  width: 100%;
  margin: 0 auto;

  .img_consult {
    position: fixed;
    right: 100px;
    bottom: 100px;
    cursor: grab;
    width: 80px;
    user-select: none;
    z-index: 9999;
  }

  //.consult_diolog {
  //  position: fixed;
  //  //top: 16%;
  //  //left: 22%;
  //  z-index: 1000;
  //  opacity: 0;
  //  transform: translate(50%, -50%) scale(0.8);
  //  transition: all 0.3s ease;
  //
  //  &.show {
  //    opacity: 1;
  //    transform: translate(50%, -50%) scale(0.9);
  //  }
  //}
  .consult_diolog {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1000;
    opacity: 0;
    transform: translate(-50%, -50%) scale(1);
    transition: all 0.3s ease;

    /* GPU 渲染优化，防止高分屏细线 */
    backface-visibility: hidden;
    transform-style: preserve-3d;
    will-change: transform, opacity;

    /* 让渲染更稳定 */
    image-rendering: -webkit-optimize-contrast;

    &.show {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .df_img {
    width: 100%;
    background: #3475ef;

    .df_logo {
      box-sizing: border-box;
      width: 3.75rem;
      height: 0.6rem;
      padding: 0.08rem 0.58rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .nav-center {
      height: 0.6rem;
      width: calc(100% - 3.75rem - 2rem);
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      .item {
        display: block;
        height: 0.6rem;
        line-height: 0.6rem;
        padding: 0 0.2rem;
        text-decoration: none;
        color: #fff;
        font-size: 0.16rem;
        font-weight: 600;
      }

      .link_active {
        font-size: 0.2rem;
        background: #2c63ca;
      }
    }

    .login {
      width: 2rem;

      &_btn {
        width: 0.6rem;
        height: 0.24rem;
        line-height: 0.24rem;
        text-align: center;
        margin: 0.04rem;
        transform: translateX(-20%);
        cursor: pointer;
        user-select: none;
        border-radius: 0.05rem;
        letter-spacing: 0.01rem;
        border: 0.001rem solid #ffffff;
        box-shadow: 0rem 0.04rem 1rem -0.02rem rgba(52, 117, 239, 0.35);
        font-size: 0.12rem;
        position: relative;

        &:nth-child(1) {
          color: #ffffff;
          background: #3475ef;
          border-color: #ffffff;
        }

        &:nth-child(1):hover {
          background: #4582f0;
        }

        &:nth-child(2) {
          color: #3475ef;
          background: #ffffff;
          border-color: #3475ef;
        }

        &:nth-child(2):hover {
          background: #efefef;
        }

        &:active::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 0.6rem;
          height: 0.24rem;
          border-radius: 0.05rem;
          background: rgba($color: #000, $alpha: 0.1);
        }
      }
    }
  }

  .df_banner {
    height: 2.92rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  ::v-deep .el-dialog {
    background-image: url('@/assets/images/bg_login.png');
    background-size: 100% 50%;
    background-repeat: no-repeat;
    border-radius: 0.18rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px !important;

    &__header {
      padding: 0.3rem 0.5rem;
    }

    &__body {
      padding: 0 1.15rem 0.35rem;
    }
  }

  .service-diolog {
    ::v-deep .el-dialog {
      &__header {
        padding: 20px !important;
      }

      &__body {
        padding: 0 20px 20px 20px !important;
      }
    }
  }

  .dialog {
    &_title {
      font-size: 0.2rem;
      color: #3d3d3d;
      letter-spacing: 0.02rem;
      font-weight: bold;
    }

    &_body {
      --font-size: 0.14rem;

      &_input {
        border-bottom: 0.01rem solid #bdc3d9;
        margin-bottom: 0.3rem;

        p {
          font-size: var(--font-size);
        }

        p.phone {
          width: 0.5rem;
          font-weight: bold;
          color: #3d3d3d;
          border-right: 0.01rem solid #bdc3d9;
        }

        p.code {
          width: 1.2rem;
          color: #3475ef;
          text-align: right;
          cursor: pointer;
          user-select: none;

          &:hover {
            color: #3678eb;
          }

          &:active {
            color: #0347bd;
          }

          &.disabled {
            color: #bdc3d9;
            cursor: not-allowed;
          }

          &.disabled:hover {
            color: #bdc3d9;
          }

          &.disabled:active {
            color: #bdc3d9;
          }
        }

        ::v-deep {
          .el-input {
            &__inner {
              background: none;
              height: 0.4rem;
              border: 0;
              font-size: var(--font-size);
              padding: 0.1rem;
            }
          }
        }
      }

      &_btn {
        background: #bdc3d9;
        color: #ffffff;
        font-size: var(--font-size);
        height: 0.4rem;
        border-radius: 0.06rem;
        letter-spacing: 0.1rem;
        margin: 0.3rem 0 0.2rem;
        position: relative;

        &:active::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 0.06rem;
          background: rgba($color: #000, $alpha: 0.1);
        }
      }

      &_check {
        --font-size: 0.11rem;

        span {
          font-size: var(--font-size);
          color: #3475ef;
          cursor: pointer;
        }

        ::v-deep {
          .el-checkbox {
            display: flex;
            align-items: center;

            &__input {
              scale: 0.8;
            }

            &__label {
              padding-left: 0.1rem;
              font-size: var(--font-size);
              letter-spacing: 0.01rem;
              color: #3d3d3d !important;
            }
          }

          .is-checked .el-checkbox__inner {
            background-color: #3475ef;
          }
        }
      }
    }
  }

  .login_out {
    color: #fff;

    .el-dropdown-link {
      padding-left: 0.1rem;
      display: inline-flex;
      cursor: pointer;
      color: #ffffff;
    }
  }

  .dialog_body_btn {
    cursor: pointer;
  }
}

.consult-mask {
  backface-visibility: hidden;
  transform-style: preserve-3d;
  will-change: opacity;
}
</style>
